module.exports = __webpack_public_path__ + "media/assets/images/blog/scream_at_phone-05333142594026a1cc8ccfb1f63af962.jpeg";